import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const MATCH_STATUS_TYPES = {
  UNANSWERED: 'unanswered',
  UNREAD: 'unread',
  UPDATED: 'updated',
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const matchesInitialState = Object.keys(MATCH_STATUS_TYPES).reduce(
  (acc, key) => {
    acc[MATCH_STATUS_TYPES[key]] = null;
    return acc;
  },
  {}
);

export const filterInitialState = {
  status: 'active', // 'active' or 'inactive'
  conversations: 'all', // 'all', 'started', 'notStarted'
  type: 'all', // 'all', 'directswap', 'triangleswap'
  matchState: 'all',
  showFavoritesOnly: false
};

const state = {
  matches: matchesInitialState,
  isLoadingMatches: null,
  isLoadingStatusCounts: null,
  activeTab: MATCH_STATUS_TYPES.ACTIVE,
  initialMatchStatusCounts: null,
  matchStatusCounts: null,
  newMatch: null,
  filter: filterInitialState,
  matchRequests: null,
  isLoadingMatchRequests: null,
  activeToggleTab: 'matches', // 'matches' or 'requests'
  matchesHasMore: true
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
